// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/67fcdb45ac2cac389cd8.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"e355f1adf4392999c56b","211":"21842a8225dca7089a5f","212":"7104835adc2d7f668255"}[chunkId] + ".chunk.js";
};